import React from "react";
//MDBShim Imports
import Button from "../../Component/MDBShim/Button";
import Container from "../../Component/MDBShim/Container";
import Card from "../../Component/MDBShim/Card";
import CardBody from "../../Component/MDBShim/CardBody";
import CardHeader from "../../Component/MDBShim/CardHeader";
import Col from "../../Component/MDBShim/Col";
import DataTable from "../../Component/MDBShim/DataTable";
import Row from "../../Component/MDBShim/Row";
import Spinner from "../../Component/MDBShim/Spinner";
import toast from "../../Component/MDBShim/toast";
import ToastContainer from "../../Component/MDBShim/ToastContainer";
import DatePicker from "../../Component/MDBShim/DatePicker";
import Fa from "../../Component/MDBShim/Fa";
import MDBIcon from "../../Component/MDBShim/MDBIcon";
import ReactTooltip from "react-tooltip";
import ReportsService from "../Security/ReportsService/reportsService";
import LayerLegacy from "../../LayerLegacy";
import Exporter from "../../Utility/Exporter";
import moment from "moment";
import MainContext from "../../Context/MainContext/MainContext";
import * as Sentry from "@sentry/browser";

export default class bonusReport extends LayerLegacy {
  constructor(props) {
    super(props);

    const bonusData = {
      columns: [
        {
          label: "Order Id",
          field: "orderId",
          sort: "asc",
          width: 200,
        },
        {
          label: "Order Type",
          field: "orderType",
          sort: "asc",
          width: 200,
        },
        {
          label: "Status",
          field: "status",
          sort: "asc",
          width: 200,
        },
        {
          label: "Reason",
          field: "reason",
          sort: "asc",
          width: 200,
        },
        {
          label: "Username",
          field: "username",
          sort: "asc",
          width: 200,
        },
        {
          label: "Name",
          field: "name",
          sort: "asc",
          width: 200,
        },
        {
          label: "Email",
          field: "email",
          sort: "asc",
          width: 200,
        },
        {
          label: "Patient Name",
          field: "patientName",
          sort: "asc",
          width: 200,
        },
        {
          label: "Account",
          field: "account",
          sort: "asc",
          width: 200,
        },
        {
          label: "Setup Date",
          field: "setupDate",
          sort: "asc",
          width: 200,
        },
        {
          label: "Payor Source",
          field: "payorSource",
          sort: "asc",
          width: 200,
        },
        {
          label: "Insurance",
          field: "insurance",
          sort: "asc",
          width: 200,
        },
        {
          label: "Category",
          field: "category",
          sort: "asc",
          width: 200,
        },
        {
          label: "Product",
          field: "product",
          sort: "asc",
          width: 200,
        },
        {
          label: "Total Points",
          field: "totalPoints",
          sort: "asc",
          width: 200,
        },
      ],
      rows: [],
    };

    this.state = {
      allResults: [],
      bonusData,
      startDate: "",
      endDate: "",
    };
  }

  static contextType = MainContext;

  componentDidMount() {
    Sentry.captureMessage("Bonus page accessed", {
      fingerprint: ["bonusAccess"],
    });
  }

  getBonusReport() {
    const st = this.state;
    const filters = {};

    if (!st.startDate || !st.endDate) {
      return;
    }

    filters.start = moment(st.startDate, "YYYY-MM-DD").format("MM/DD/YYYY");
    filters.end = moment(st.endDate, "YYYY-MM-DD").format("MM/DD/YYYY");

    this.setState({ isLoaded: false });

    return ReportsService.getBonusReport(filters)
      .then((res) => {
        this.setState({ allResults: res });
        this.formatRows(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  handleDatePickerChange = (property, value) => {
    this.setState({ [property]: value });
  };

  formatRows(setups) {
    const dt = { ...this.state.bonusData };
    const ary = [];

    setups.forEach((sale) => {
      ary.push({
        orderId: sale.id,
        orderType: sale.orderType,
        status: sale.status,
        reason: sale.reason,
        username: sale.username,
        name: sale.name,
        email: sale.email,
        patientName: sale.patientName
          ? sale.patientName.replace(/,/g, " ")
          : "No Patient Name",
        account: sale.account ? sale.account.replace(/,/g, " ") : "No Account",
        setupDate: sale.setupDate,
        payorSource: sale.payorSource,
        insurance: sale.insurance || "No Insurance",
        category: sale.category
          ? sale.category.replace(/,/g, " ")
          : "No Category",
        product: sale.product ? sale.product.replace(/,/g, " ") : "No Product",
        totalPoints: sale.totalPoints,
      });
    });
    dt.rows = ary;

    this.setState({
      bonusData: dt,
      isLoaded: true,
    });
  }

  clientCSV(stateData) {
    if (stateData == null || !stateData.rows.length) {
      toast.warn("No data to export");
      return;
    }

    const csvRows = [];
    const columns = [];
    stateData.columns.forEach((column) => {
      columns.push(column.label);
    });
    csvRows.push(columns);

    stateData.rows.forEach((row) => {
      const csvRow = [];
      stateData.columns.forEach((column) => {
        csvRow.push(row[column.field]);
      });
      csvRows.push(csvRow);
    });

    const filename = `Bonus Report - ${moment(new Date()).format("YYYY-MM-DD h mm a")}.csv`;

    Exporter.exportCSV(csvRows, filename);
  }

  renderLoadingSpinner() {
    return (
      <Container className="mt-5">
        <div style={{ textAlign: "center", verticalAlign: "center" }}>
          <Spinner multicolor />
        </div>
      </Container>
    );
  }

  renderContent() {
    if (this.state.isLoaded === false) {
      return this.renderLoadingSpinner();
    }

    return (
      <div style={{ paddingBottom: "4%" }}>
        <Card style={{ marginLeft: "4%", marginRight: "4%" }}>
          <ToastContainer
            hideProgressBar={false}
            newestOnTop={true}
            autoClose={5000}
          />

          <CardHeader style={{ backgroundColor: "#5881C1" }}>
            <Row style={{ display: "flex", justifyContent: "space-around" }}>
              <Col size={"2"} style={{ color: "#FFF" }}>
                <div className="expenseDateOptions">
                  <DatePicker
                    format="MM/DD/YYYY"
                    placeholder={"No Date"}
                    valueDefault={"No Date"}
                    invalidDateMessage={""}
                    showTodayButton
                    value={this.state.startDate || ""}
                    getValue={this.handleDatePickerChange.bind(
                      this,
                      "startDate",
                    )}
                    mask={[
                      /\d/,
                      /\d/,
                      "/",
                      /\d/,
                      /\d/,
                      "/",
                      /\d/,
                      /\d/,
                      /\d/,
                      /\d/,
                    ]}
                    label="Start Date"
                  />
                </div>
              </Col>

              <Col size={"2"} style={{ color: "#FFF" }}>
                <div className="expenseDateOptions">
                  <DatePicker
                    format="MM/DD/YYYY"
                    placeholder={"No Date"}
                    valueDefault={"No Date"}
                    invalidDateMessage={""}
                    showTodayButton
                    value={this.state.endDate || ""}
                    getValue={this.handleDatePickerChange.bind(this, "endDate")}
                    mask={[
                      /\d/,
                      /\d/,
                      "/",
                      /\d/,
                      /\d/,
                      "/",
                      /\d/,
                      /\d/,
                      /\d/,
                      /\d/,
                    ]}
                    label="End Date"
                  />
                </div>
              </Col>

              <Col size={"5"} />

              <Col size={"1"} style={{ textAlign: "right" }}>
                <Button
                  floating
                  rounded
                  size={"sm"}
                  data-tip={"Search"}
                  style={{ marginTop: "1.5rem" }}
                  onClick={() => this.getBonusReport()}
                  color={"warning"}
                >
                  <Fa icon={"search"} />
                </Button>
              </Col>
            </Row>
          </CardHeader>

          <CardBody>
            <DataTable
              search
              paginated
              data={this.state.bonusData}
              responsive
              fixed
              striped
              bordered
            ></DataTable>

            <Button
              className={"downloadCsvButton"}
              floating
              size="sm"
              color={"indigo"}
              data-tip={"Download CSV"}
              onClick={this.clientCSV.bind(this, this.state.bonusData)}
            >
              <MDBIcon icon="download" style={{ fontSize: "2em" }} />
            </Button>

            <ReactTooltip />
          </CardBody>
        </Card>
        <ReactTooltip />
      </div>
    );
  }
}
